<template>
    <div>
      <div class="case" ref="box">
        <img class="caseimg1" src="../assets/images/table_yanfabaoxiao.png">
        <div class="caseword">
          <p class="Shenqingbumen">{{Shenqingbumen}}</p>
          <p class="Jingbanren">{{Jingbanren}}</p>
          <p class="Tianzhiriqi">{{Tianzhiriqi}}</p>
          <p class="Shoukuandanwei">{{Shoukuandanwei}}</p>
          <p class="Contact">{{Contact}}</p>
          <p class="Productname">{{Productname}}</p>
          <p class="Reason">{{Bomsnname}}{{Reason}}</p>
          <p class="Productnum">{{Productnum}}</p>
          <p class="Productprice">{{Productprice}}</p>
          <p class="Money">{{Money}}</p>
          <p class="Bumenzhuguan">{{Bumenzhuguan}}</p>
          <p class="Caiwu">{{Caiwu}}</p>
          <p class="Fuzongjingli">{{Fuzongjingli}}</p>
          <p class="Zongjingli">{{Zongjingli}}</p>
          <p class="Chuna">{{Chuna}}</p>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      Shenqingbumen: '',
      Tianzhiriqi: '',
      Shoukuandanwei: '',
      Contact: '',
      Bomsnname: '',
      Productname: '',
      Productnum: '',
      Productprice: '',
      Reason: '',
      Money: '',
      Jingbanren: '',
      Bumenzhuguan: '',
      Fuzongjingli: '',
      Zongjingli: '',
      Caiwu: '',
      Chuna: ''
    }
  },
  mounted () {
  },
  methods: {
    InitData () {
      this.Shenqingbumen = ''
      this.Tianzhiriqi = ''
      this.Shoukuandanwei = ''
      this.Contact = ''
      this.Bomsnname = ''
      this.Productname = ''
      this.Productnum = ''
      this.Productprice = ''
      this.Reason = ''
      this.Money = ''
      this.Jingbanren = ''
      this.Bumenzhuguan = ''
      this.Fuzongjingli = ''
      this.Zongjingli = ''
      this.Caiwu = ''
      this.Chuna = ''
    },
    LoadData (parentdata, forprint) {
      this.InitData()
      console.log(parentdata)
      var that = this
      this.$nextTick(() => {
        that.Shenqingbumen = parentdata.CurJigouName
        that.Tianzhiriqi = Vue.prototype.SplitTimeString(parentdata.Createtime)
        that.Shoukuandanwei = parentdata.Shoukuandanwei
        that.Contact = parentdata.Contact
        that.Bomsnname = '【' + parentdata.Bomsnname + '】'
        that.Productname = parentdata.Productname
        that.Productnum = parentdata.Productnum
        that.Productprice = parentdata.Productprice
        that.Reason = parentdata.Reason
        that.Money = parentdata.Money
        that.Jingbanren = parentdata.Name1
        that.Bumenzhuguan = parentdata.Name2
        that.Caiwu = parentdata.Name3
        that.Fuzongjingli = parentdata.Name4
        that.Zongjingli = parentdata.Name5
        if (forprint == 0) {
          that.Chuna = ''
        } else {
          that.Chuna = localStorage.getItem('Nicename')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.case{
    width: 839px;
    height: 298px;
    position: relative;
}

.caseimg1{
  width: 839px;
  height: 298px;
  position: absolute;
  z-index: 10;
}

.caseword{
  color:#000000;
  font-size: 14px;
}

.Shenqingbumen{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 25px;
}

.Tianzhiriqi{
  position: absolute;
  z-index: 30;
  left: 705px;
  top: 25px;
}

.Shoukuandanwei{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 59px;
}

.Contact{
  position: absolute;
  z-index: 30;
  left: 495px;
  top: 59px;
}

.Productname{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 93px;
  right: 5px;
  word-wrap: break-word;
  word-break: break-all;
}

.Productnum{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 223px;
}

.Productprice{
  position: absolute;
  z-index: 30;
  left: 355px;
  top: 223px;
}

.Reason{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 161px;
  right: 5px;
  word-wrap: break-word;
  word-break: break-all;
}

.Money{
  position: absolute;
  z-index: 30;
  left: 630px;
  top: 223px;
}

.Jingbanren{
  position: absolute;
  z-index: 30;
  left: 490px;
  top: 25px;
}

.Bumenzhuguan{
  position: absolute;
  z-index: 30;
  left: 215px;
  top: 257px;
}

.Caiwu{
  position: absolute;
  z-index: 30;
  left: 350px;
  top: 257px;
}

.Fuzongjingli{
  position: absolute;
  z-index: 30;
  left: 488px;
  top: 257px;
}

.Zongjingli{
  position: absolute;
  z-index: 30;
  left: 625px;
  top: 257px;
}

.Chuna{
  position: absolute;
  z-index: 30;
  left: 770px;
  top: 257px;
}
</style>
